import api from "../apiClient";

// Account Brief — docs/ACCOUNT_BRIEF.md (crm_backend). Tenant is server-side.
// `shown_at` is when the item was first rendered: the server turns it into
// dwell time for the rubber-stamp metric, so send it on every decision.
export const getAccountBrief = (customerId, audience = "office") =>
  api.get(`/account-brief/customers/${customerId}/`, { params: { audience } });

export const addBriefItem = (customerId, body) =>
  api.post(`/account-brief/customers/${customerId}/items/`, body);

const act = (id, verb, body = {}) => api.post(`/account-brief/items/${id}/${verb}/`, body);
export const confirmBriefItem = (id, body) => act(id, "confirm", body);
export const rejectBriefItem = (id, body) => act(id, "reject", body);
export const retractBriefItem = (id, body) => act(id, "retract", body);
export const verifyBriefItem = (id, body) => act(id, "verify", body);
export const resolveBriefConflict = (id, body) => act(id, "resolve-conflict", body);
export const undoAutoBriefItem = (id, body) => act(id, "undo-auto", body);
export const resolveBriefPromise = (id, body) => act(id, "resolve", body);
